<template>
    <section class="section">
        <div class="content has-text-grey has-text-centered">
            <b-icon :icon="i" size="is-large" />
            <p style="margin-top: 1em">{{ text }}</p>
            <!-- What to do about it. A list that found nothing is a dead end until
                 it offers the one move that follows — creating what was searched
                 for — so the offer lives with the message, not in a toolbar the
                 reader has already looked away from. -->
            <p v-if="actionLabel">
                <b-button type="is-primary" size="is-small" :icon-left="actionIcon" @click="$emit('action')">
                    {{ actionLabel }}
                </b-button>
            </p>
        </div>
    </section>
</template>

<script>
export default {
    props: {
        label: {},
        icon: {},
        actionLabel: { type: String, default: null },
        actionIcon: { type: String, default: 'plus' }
    },

    emits: ['action'],

    computed: {
        i() {
            return this.icon ? this.icon : 'emoticon-happy-outline';
        },
        text() {
            return this.label || i18n.t('No item found.');
        }
    }
};
</script>
